import { OrgRoles } from '@/const';
import Dummy from '@/components/Dummy.vue';

export default [
    {
        path: '/external_purchases/:mode(create|edit_draft)/:id(\\d+)?',
        component: () => import(/* webpackChunkName: "main" */ '@/components/externalPurchases/Create'),
        name: 'ExternalPurchaseCreate',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
    },
    {
        path: '/external_purchases/:id(\\d+)/edit',
        component: () => import(/* webpackChunkName: "main" */ '@/components/externalPurchases/ExternalPurchaseEdit'),
        name: 'ExternalPurchaseEdit',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
    },
    {
        path: '/external_purchases/:id(\\d+)',
        name: 'ExternalPurchaseShow',
        component: () => import(/* webpackChunkName: "main" */ '@/components/externalPurchases/Show.vue')
    },
    {
        path: '/purchases/create/:id?',
        redirect: () => {
            return `/purchases/grouped/fl44/item/create`;
        }
    },
    {
        path: '/purchases/show/:id',
        component: () => import(/* webpackChunkName: "main" */ '@/components/purchases/Show'),
        name: 'PurchasesShow'
    },
    {
        path: '/purchases',
        redirect: { name: 'PurchasesList', params: { path: 'new' } },
        name: 'TestTest',
        component: Dummy,
        children: []
    },
    {
        path: '/purchases/:id/new_offer',
        name: 'PurchasesNewOffer',
        component: () => import(/* webpackChunkName: "main" */ '@/components/purchases/NewOffer')
    },
    {
        path: '/purchases/fl44/create',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl44/create.vue'),
        name: 'Fl44PurchaseCreate',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
    },
    {
        path: '/purchases/fl44/:id/edit',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl44/create.vue'),
        name: 'Fl44PurchaseEdit',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
    },
    {
        path: '/purchases/fl44_uv/create',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl44-unknown-volume/create.vue'),
        name: 'Fl44UnknownVolumePurchaseCreate',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
    },
    {
        path: '/purchases/fl44_uv/:id(\\d+)/edit',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl44-unknown-volume/create.vue'),
        name: 'Fl44UnknownVolumePurchaseEdit',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
    },
    {
        path: '/purchases/fl44_uv/:id(\\d+)/show',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl44-unknown-volume/show.vue'),
        name: 'Fl44UnknownVolumePurchaseShow'
    },
    {
        path: '/purchases/fl44_uv/:id(\\d+)/duration_change',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl44-unknown-volume/duration-change.vue'),
        name: 'Fl44UnknownVolumePurchaseDurationChange'
    },
    {
        path: '/purchases/fl44_uv/:id(\\d+)/new_proposal',
        name: 'Fl44UnknownVolumePurchaseNewProposal',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl44-unknown-volume/proposal-create.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/purchases/fl223/create',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl223/create.vue'),
        name: 'Fl223PurchaseCreate',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL223 }
    },
    {
        path: '/purchases/fl223/:id/edit',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl223/create.vue'),
        name: 'Fl223PurchaseEdit',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL223 }
    },
    {
        path: '/purchases/fl223/:id/show',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl223/show.vue'),
        name: 'Fl223PurchaseShow'
    },
    {
        path: '/purchases/fl223/:id/new_proposal',
        name: 'Fl223PurchaseNewProposal',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/fl223/proposal-create.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/purchases/commercial/create',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/commercial/create.vue'),
        name: 'CommercialPurchaseCreate',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_COMMERCIAL }
    },
    {
        path: '/purchases/commercial/:id/edit',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/commercial/create.vue'),
        name: 'CommercialPurchaseEdit',
        meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_COMMERCIAL }
    },
    {
        path: '/purchases/commercial/:id/show',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/commercial/show.vue'),
        name: 'CommercialPurchaseShow'
    },
    {
        path: '/purchases/commercial/:id/new_proposal',
        name: 'CommercialPurchaseNewProposal',
        component: () => import(/* webpackChunkName: "main" */ '@/components/products/commercial/proposal-create.vue'),
        meta: { requiresAuth: true }
    }
];
